import * as FiIcons from 'react-icons/fi';

/**
 * Icon registries (T22.4). Keep the agent registry keys in sync with the icon
 * vocabulary in src/mocks/*.js — an unknown key resolving to undefined is a
 * React #130 crash in production. Safe helper: agentIcon(key) ALWAYS returns
 * a component; consumers should use it or render with a fallback.
 */
export const agentIconRegistry = {
  command: FiIcons.FiCommand,
  search: FiIcons.FiSearch,
  edit3: FiIcons.FiEdit3,
  trendingUp: FiIcons.FiTrendingUp,
  dollarSign: FiIcons.FiDollarSign,
  shield: FiIcons.FiShield,
  // 10-agent roster keys (mocks/dashboard.js ids 6–10 + scheduler consumers)
  headphones: FiIcons.FiHeadphones,
  gitBranch: FiIcons.FiGitBranch,
  database: FiIcons.FiDatabase,
  checkCircle: FiIcons.FiCheckCircle
};

/** Safe lookup — always returns a component, never undefined. */
export function agentIcon(key) {
  return agentIconRegistry[key] || FiIcons.FiCpu;
}

export const approvalIconRegistry = {
  trendingUp: FiIcons.FiTrendingUp,
  edit3: FiIcons.FiEdit3,
  dollarSign: FiIcons.FiDollarSign
};

export const navigationIconRegistry = {
  grid: FiIcons.FiGrid,
  checkSquare: FiIcons.FiCheckSquare,
  cpu: FiIcons.FiCpu,
  calendar: FiIcons.FiCalendar,
  share2: FiIcons.FiShare2,
  radio: FiIcons.FiRadio,
  terminal: FiIcons.FiTerminal,
  settings: FiIcons.FiSettings,
  moreHorizontal: FiIcons.FiMoreHorizontal,
  x: FiIcons.FiX,
  menu: FiIcons.FiMenu
};